<template>
  <AlertForm :alert="alert" :onSubmit="submit"></AlertForm>
</template>

<script>
import AlertForm from './Alert-Form.vue';
import { busEvent } from '../../main';

export default {
  name: 'EditAlert',
  components: {
    AlertForm,
  },
  created() {
    this.$store.dispatch('alerts/getAlert', this.$route.params.id);
  },
  computed: {
    alert() {
      return this.$store.state.alerts.alert;
    },
  },
  methods: {
    submit() {
      this.$store.dispatch('alerts/updateAlert', { id: this.$route.params.id, body: this.alert })
        .then(() => {
          busEvent.$emit('succesPopupCreated', 'Informatie actualizata');
          this.$router.push({ path: '/alerts' });
        });
    },
  },
};
</script>
